import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

import logo from "../../images/logo-full.svg";
import "./maintenance.css";

const Maintenance = () => {
  const { t } = useTranslation(["maintenance"]);

  return (
    <main className="maintenance">
      <Helmet>
        <title>{t("page_title")}</title>
        <meta name="description" content={t("message")} />
      </Helmet>
      <img className="maintenance-logo" src={logo} alt="SocialPika" />
      <h1>{t("title")}</h1>
      <p>{t("message")}</p>
      <p className="maintenance-note">{t("accounts_note")}</p>
      <p>
        <a href="mailto:contact@socialpika.com">{t("contact")}</a>
      </p>
      <nav className="maintenance-links">
        <a href="/terms">{t("terms")}</a>
        <a href="/privacy">{t("privacy")}</a>
      </nav>
    </main>
  );
};

export default Maintenance;
